import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Pagination } from '../../models/pagination';

@Component({
  selector: 'lib-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss'],
  standalone: false
})
export class PaginationComponent implements OnInit {
  @Input()
  pagination: Pagination;

  @Input()
  pagesToShow: number = 5;

  @Output()
  public pageChanged = new EventEmitter<Pagination>();

  public get pageArray(): number[] {
    //Generates an array from the number of pages specified in the pagination.
    //It will start from 1, and go in order up to the number of pages.
    //This is used so we can ngFor to display the buttons dynamically.
    //Moved into a calculated property so it updates when the inputs update.
    return Array(this.pagination.Pages)
      .fill(0)
      .map((x, i) => i + 1);
  }

  ngOnInit() {}

  public nextClicked() {
    const newPagination: Pagination = {
      ...this.pagination,
      Page: ++this.pagination.Page
    };
    this.pageChanged.emit(newPagination);
  }
  public previousClicked() {
    const newPagination: Pagination = {
      ...this.pagination,
      Page: --this.pagination.Page
    };
    this.pageChanged.emit(newPagination);
  }
  public goToPage(page) {
    const newPagination: Pagination = {
      ...this.pagination,
      Page: page
    };
    this.pageChanged.emit(newPagination);
  }

  public showPageButton(pageNumber: number): boolean {
    if (this.pagination.Pages === 0) {
      return false;
    }
    //If the number of pages is less than or equal to the number we are allowed
    //show, then show all of them.
    if (this.pagination.Pages <= this.pagesToShow) {
      return true;
    }
    //Always show the first page and the last page
    if (pageNumber === 1 || pageNumber === this.pagination.Pages) return true;
    //If current page is the first page, we need to show it, the last page,
    // and the first x - 2 pages defined by the pagesToShow variable
    //We subtract 2 because the first and last button are always shown, and
    //count against our limit.
    const additionalPagesToShow = this.pagesToShow - 2;
    if (this.pagination.Page === 1 || this.pagination.Page === 2) {
      return pageNumber <= additionalPagesToShow + 1;
    }
    //Likewise, for the last page we need to display it and x-2 pages prior.
    if (
      this.pagination.Pages === this.pagination.Page ||
      this.pagination.Page === this.pagination.Pages - 1
    ) {
      return pageNumber >= this.pagination.Pages - additionalPagesToShow;
    }
    //Finally, if we aren't on the first or last page, we show the current page,
    // The previous page, and the next page.
    return pageNumber >= this.pagination.Page - 1 && pageNumber <= this.pagination.Page + 1;
  }

  public showElipsesBeforeButton(pageNumber: number): boolean {
    //never show ellipses before first page.
    if (pageNumber === 1) return false;
    //if the button is shown but the one before it isn't, display ellipses
    return this.showPageButton(pageNumber) && !this.showPageButton(pageNumber - 1);
  }
}
